import { render, staticRenderFns } from "./teamEngagementLabels.vue?vue&type=template&id=04247b8a&scoped=true&"
import script from "./teamEngagementLabels.vue?vue&type=script&lang=ts&"
export * from "./teamEngagementLabels.vue?vue&type=script&lang=ts&"
import style0 from "./teamEngagementLabels.vue?vue&type=style&index=0&id=04247b8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04247b8a",
  null
  
)

export default component.exports